import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-plus fa-xl",
  style: {"color":"#ffffff"}
}, null, -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_8 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "cell-color text-center" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_27 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "text-center cell-color" }

import { ref, onMounted, watch, inject } from "vue";
import TableFooter from "@/components/TableFooter.vue";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";
import {
  TransactionAccountType,
  TransactionStateType,
} from "@/core/types/StateInfos";
import { ActionType } from "@/core/types/Actions";
import WithdrawInfo from "@/projects/tenant/modules/Payment/modal/WithdrawInfo.vue";
import BalanceShow from "@/components/BalanceShow.vue";
import { PaymentStatusTypes } from "@/core/types/PaymentTypes";
import { useRoute } from "vue-router";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";
import CreateWithdrawalForAccount from "@/projects/tenant/modules/accounts/components/modal/CreateWithdrawalForAccount.vue";
import { ArrowDown } from "@element-plus/icons-vue";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import svc from "@/projects/tenant/modules/Payment/services/PaymentService";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetailWithdrawal',
  setup(__props) {

const isLoading = ref(false);
const { t } = useI18n();
const transactions = ref(Array<any>());
const withdrawInfoRef = ref<InstanceType<typeof WithdrawInfo>>();
const createWithdrawalForAccountRef =
  ref<InstanceType<typeof CreateWithdrawalForAccount>>();

const accountDetails = inject(AccountInjectionKeys.ACCOUNT_DETAILS);

const criteria = ref({
  page: 1,
  size: 10,
  accountId: accountDetails.value?.id,
});

const route = useRoute();
watch(
  () => route.query.id,
  () => {
    if (route.query.id) {
      fetchData(1);
    }
  }
);

onMounted(async () => {
  await fetchData(criteria.value.page);
});

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  isLoading.value = true;
  // const res = await svc.queryWithdrawals(criteria.value);
  const res = await PaymentService.queryWithdrawals(criteria.value);
  criteria.value = res.criteria;
  transactions.value = res.data;
  isLoading.value = false;
};

const pageChange = (page: number) => {
  fetchData(page);
};

const action = ref(ActionType.Cancel);
const openConfirmBox = inject(TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL);

const openConfirmPanel = (
  _action: ActionType,
  id: number,
  paymentId?: number
) => {
  action.value = _action;
  const _handler = {
    [ActionType.Approve]: () => PaymentService.approveWithdrawalById(id),
    [ActionType.Reject]: () => PaymentService.rejectWithdrawalById(id),
    [ActionType.Cancel]: () => PaymentService.cancelWithdrawalById(id),
    [ActionType.StartExecution]: () => PaymentService.executePaymentById(id),
    [ActionType.CompletePayment]: async () => {
      if (!paymentId) {
        MsgPrompt.error("No PaymentId specified");
        return;
      }
      await PaymentService.completePaymentById(paymentId);
      await PaymentService.completeWithdrawalByPaymentId(id);
    },
  }[_action];
  if (!_handler) {
    MsgPrompt.error(t("tip.fail"));
    return;
  }
  openConfirmBox?.(
    () =>
      _handler()
        .then(() => MsgPrompt.success())
        .then(() => fetchData(criteria.value.page)),
    void 0,
    {
      confirmColor: _action === ActionType.Reject ? "danger" : "primary",
    }
  );
};
const showWithdrawInfo = async (_item: any) => {
  withdrawInfoRef.value?.show(_item);
};

const openCreateWithdrawalPanel = () => {
  createWithdrawalForAccountRef.value?.show();
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.withdrawal")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-success fs-6",
            onClick: openCreateWithdrawalPanel
          }, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("action.createWithdrawal")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_8, [
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.paymentStatus")), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.paymentID")), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.currency")), 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.withdrawAmount")), 1),
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.sourceBalance")), 1),
              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
              _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && transactions.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.$t(`type.transactionState.${item.stateId}`).replace(
                    /^Withdrawal\s+/,
                    ""
                  )), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", {
                    'badge-primary':
                      item.payment.status === _unref(PaymentStatusTypes).Pending,
                    'badge-success':
                      item.payment.status === _unref(PaymentStatusTypes).Completed,
                    'badge-danger':
                      item.payment.status === _unref(PaymentStatusTypes).Failed,
                    'badge-warning':
                      item.payment.status === _unref(PaymentStatusTypes).Executing,
                  }])
                        }, _toDisplayString(_ctx.$t(`type.paymentStatus.${item.payment.status}`)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(item.id), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.$t(`type.currency.${item.currencyId}`)), 1),
                      _createElementVNode("td", _hoisted_24, [
                        _createVNode(BalanceShow, {
                          "currency-id": item.currencyId,
                          balance: item.amount
                        }, null, 8, ["currency-id", "balance"])
                      ]),
                      _createElementVNode("td", _hoisted_25, [
                        _createVNode(BalanceShow, {
                          "currency-id": item.currencyId,
                          balance: item.source.balanceInCents
                        }, null, 8, ["currency-id", "balance"]),
                        (
                    item.source.accountType === _unref(TransactionAccountType).Wallet
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Wallet "))
                          : _createCommentVNode("", true),
                        (
                    item.source.accountType ===
                    _unref(TransactionAccountType).TradeAccount
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, " Account (" + _toDisplayString(item.source.displayNumber) + ") ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_28, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.payment.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(item.operatorName), 1),
                      _createElementVNode("td", _hoisted_30, [
                        _createVNode(_component_el_dropdown, { trigger: "click" }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_dropdown_item, {
                                  onClick: ($event: any) => (showWithdrawInfo(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("action.showPaymentInfo")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                (
                          item.stateId ===
                          _unref(TransactionStateType).WithdrawalCreated
                        )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createVNode(_component_el_dropdown_item, {
                                        divided: "",
                                        onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Approve, item.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("action.approve")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_el_dropdown_item, {
                                        onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Reject, item.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("action.reject")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_el_dropdown_item, {
                                        divided: "",
                                        onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Cancel, item.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (
                          item.stateId ===
                          _unref(TransactionStateType).WithdrawalTenantApproved
                        )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (
                            item.payment.status === _unref(PaymentStatusTypes).Pending
                          )
                                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                            key: 0,
                                            divided: "",
                                            onClick: ($event: any) => (
                            openConfirmPanel(
                              _unref(ActionType).StartExecution,
                              item.payment.id
                            )
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("action.startProcessing")), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : (
                            item.payment.status === _unref(PaymentStatusTypes).Executing
                          )
                                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                              key: 1,
                                              divided: "",
                                              onClick: ($event: any) => (
                            openConfirmPanel(
                              _unref(ActionType).CompletePayment,
                              item.id,
                              item.payment.id
                            )
                          )
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("action.completePayment")), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              class: "btn btn-secondary btn-sm"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.action")), 1),
                                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ArrowDown))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(TableFooter, {
          onPageChange: pageChange,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(WithdrawInfo, {
      ref_key: "withdrawInfoRef",
      ref: withdrawInfoRef
    }, null, 512),
    _createVNode(CreateWithdrawalForAccount, {
      ref_key: "createWithdrawalForAccountRef",
      ref: createWithdrawalForAccountRef,
      onFetchData: fetchData
    }, null, 512)
  ]))
}
}

})